(() => {
  const statusRegion = document.getElementById('ThemeStatus');

  const announce = (message) => {
    if (!statusRegion) return;
    statusRegion.textContent = '';
    window.setTimeout(() => { statusRegion.textContent = message; }, 40);
  };

  const bindOnce = (element, key, callback) => {
    if (element.dataset[key] === 'true') return;
    element.dataset[key] = 'true';
    callback();
  };

  const initTheme = (root = document) => {
    root.querySelectorAll('[data-dialog-open]').forEach((button) => {
      bindOnce(button, 'dialogBound', () => {
        button.addEventListener('click', () => {
          const dialog = document.getElementById(button.dataset.dialogOpen);
          if (!dialog) return;
          button.setAttribute('aria-expanded', 'true');
          dialog.addEventListener('close', () => button.setAttribute('aria-expanded', 'false'), { once: true });
          dialog.showModal();
          const focusTarget = dialog.querySelector('[data-drawer-focus]');
          if (focusTarget) window.setTimeout(() => focusTarget.focus(), 60);
        });
      });
    });

    root.querySelectorAll('[data-dialog-close]').forEach((button) => {
      bindOnce(button, 'closeBound', () => {
        button.addEventListener('click', () => button.closest('dialog')?.close());
      });
    });

    root.querySelectorAll('dialog.drawer').forEach((dialog) => {
      bindOnce(dialog, 'backdropBound', () => {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      });
    });

    root.querySelectorAll('[data-auto-submit]').forEach((select) => {
      bindOnce(select, 'submitBound', () => {
        select.addEventListener('change', () => select.form?.submit());
      });
    });

    root.querySelectorAll('[data-quantity-change]').forEach((button) => {
      bindOnce(button, 'quantityBound', () => {
        button.addEventListener('click', () => {
          const wrapper = button.closest('[data-quantity]');
          const input = wrapper?.querySelector('input[type="number"]');
          if (!input) return;
          const step = Number(button.dataset.quantityChange || 0);
          const minimum = Number(input.min || 0);
          input.value = String(Math.max(minimum, Number(input.value || minimum) + step));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    root.querySelectorAll('[data-product-thumbnail]').forEach((button) => {
      bindOnce(button, 'thumbnailBound', () => {
        button.addEventListener('click', () => {
          const productRoot = button.closest('[data-product-root]');
          const mainImage = productRoot?.querySelector('[data-product-main-image]');
          if (!mainImage || !button.dataset.image) return;
          mainImage.src = button.dataset.image;
          if (button.dataset.imageSrcset) mainImage.srcset = button.dataset.imageSrcset;
          mainImage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      });
    });

    root.querySelectorAll('[data-product-form]').forEach((form) => {
      bindOnce(form, 'productBound', () => {
        const selector = form.querySelector('[data-variant-select]');
        const addButton = form.querySelector('[data-add-to-cart]');
        const productRoot = form.closest('[data-product-root]');
        const price = productRoot?.querySelector('[data-product-price]');
        const comparePrice = productRoot?.querySelector('[data-product-compare-price]');
        const mainImage = productRoot?.querySelector('[data-product-main-image]');

        if (selector && addButton) {
          const syncVariant = () => {
            const option = selector.options[selector.selectedIndex];
            const available = option.dataset.available === 'true';
            addButton.disabled = !available;
            addButton.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.soldOutLabel;
            if (price && option.dataset.price) price.textContent = option.dataset.price;
            if (comparePrice) {
              comparePrice.textContent = option.dataset.comparePrice || '';
              comparePrice.hidden = !option.dataset.comparePrice;
            }
            if (mainImage && option.dataset.image) {
              mainImage.src = option.dataset.image;
              if (option.dataset.imageSrcset) mainImage.srcset = option.dataset.imageSrcset;
            }
            const nextUrl = new URL(window.location.href);
            nextUrl.searchParams.set('variant', option.value);
            window.history.replaceState({}, '', nextUrl);
          };

          selector.addEventListener('change', syncVariant);
          syncVariant();
        }

        form.addEventListener('submit', () => announce('Adding item to cart'));
      });
    });

    root.querySelectorAll('[data-product-recommendations]').forEach((section) => {
      bindOnce(section, 'recommendationsBound', () => {
        if (!section.dataset.url || section.querySelector('.product-card')) return;
        fetch(section.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const replacement = html.querySelector('[data-product-recommendations]');
            if (replacement?.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
          })
          .catch(() => {});
      });
    });
  };

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.desktop-nav details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  document.addEventListener('shopify:section:load', (event) => initTheme(event.target));
  initTheme();
})();
